import { Capacitor } from '@capacitor/core';

export default {
    name: 'MaintenanceModeView',

    data() {
        return {};
    },

    methods: {
        navigateToWeb(url, method) {
            try {
                if (!Capacitor.isNativePlatform()) {
                    window.open(url);
                    return;
                }

                this.ref = window.cordova.InAppBrowser.open(
                    url,
                    method,
                    'location=no,beforeload=yes,'
                );

                this.ref.addEventListener('beforeload', (params, callback) => {
                    callback(params.url);
                });
            } catch (err) {
                window.open(url);
                return;
            }
        },

        openLinkedin() {
            this.navigateToWeb('https://www.linkedin.com/company/cobas-asset-management', '_blank');
        },

        openTwitter() {
            this.navigateToWeb('https://twitter.com/CobasFunds', '_blank');
        }
    }
};
